<template>
  <section>
    <Header></Header>
    <div class="body">
      <SectionportfolioDetailFirst :record="record" :color="record.color" :type="record.type"/>
      <SectionPortfolioDetailScreenshot :record="record" :color="record.color" v-if="record.type === 'app'"/>
      <SectionPortfolioDetailDesc :record="record" :color="record.color"/>
      <SectionPortfolioDetailImage :record="record" :color="record.color"/>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import SectionportfolioDetailFirst from "../components/SectionPortfolioDetailFirst.vue";
import SectionPortfolioDetailScreenshot from "../components/SectionPortfolioDetailScreenshot.vue";
import SectionPortfolioDetailDesc from "../components/SectionPortfolioDetailDesc.vue";
import SectionPortfolioDetailImage from "../components/SectionPortfolioDetailImage.vue";
import loginService from "../services/loginService";
import client from "../client/client";

export default {
  name: "Main",
  components: {
    Header,
    Footer,
    SectionportfolioDetailFirst,
    SectionPortfolioDetailScreenshot,
    SectionPortfolioDetailDesc,
    SectionPortfolioDetailImage,
  },
  data: function () {
    return {
      record: {},
      color: '',
    };
  },
  mounted() {
    client
      .get("/api/portfolio/detail/" + this.$route.params.id)
      .then((res) => {
        this.record = res;
        this.color = res.color;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    async login() {},
  },
};
</script>

<style scoped>

</style>
